import Swiper from 'swiper';
import { debounce } from 'debounce';
import { isMobile } from '../utils/utilities';
class PhaseTabs {
    constructor(container) {
        this.swipers = null;
        this.slides = 0;
        // Best window width max values to add the swiper. This values are also in the tiles.scss.
        // 706px/16px;
        this.twoColumnsMaxmimumWidthInEms = 44.125;
        // 1023 / 16px
        this.threeColumnsMaxmimumWidthInEms = 63.9375;
        // 1376 / 16px
        this.fourColumnsMaxmimumWidthInEms = 86;
        this.switchTab = (tab) => {
            const tabId = tab.dataset.tab;
            const tabContent = document.querySelectorAll(`.phase-tabs__content[data-tab="${tabId}"]`);
            const tabs = document.querySelectorAll(`.phase-tabs__tabs-tab[data-tab="${tabId}"]`);
            const tabContentActive = document.querySelectorAll('.phase-tabs__content--active');
            const tabActive = document.querySelectorAll('.phase-tabs__tabs-tab--active');
            if (window.innerWidth > 1016 && tabActive[0].dataset.tab === tabId) {
                return;
            }
            if (tabActive.length === 0 || tabActive[0].dataset.tab === tabId) {
                tabContentActive.forEach((content) => {
                    content.classList.remove('phase-tabs__content--active');
                });
                tabActive.forEach((tab) => {
                    tab.classList.remove('phase-tabs__tabs-tab--active');
                });
                if (!tabContentActive.length) {
                    tabContent.forEach((content) => {
                        content.classList.add('phase-tabs__content--active');
                    });
                    tabs.forEach((tab) => {
                        tab.classList.add('phase-tabs__tabs-tab--active');
                    });
                }
                return;
            }
            if (tabContent && tabContentActive && tabActive) {
                tabContentActive.forEach((content) => {
                    console.log(content);
                    content.classList.remove('phase-tabs__content--active');
                });
                tabActive.forEach((tab) => {
                    console.log(tab);
                    tab.classList.remove('phase-tabs__tabs-tab--active');
                });
                tabContent.forEach((content) => {
                    console.log(content);
                    content.classList.add('phase-tabs__content--active');
                });
                tabs.forEach((tab) => {
                    console.log(tab);
                    tab.classList.add('phase-tabs__tabs-tab--active');
                });
            }
        };
        this.addSwiper = () => {
            if (!this.swipers) {
                this.swipers = [];
                this.swiperContainers.forEach((swiperContainer) => {
                    const swiperNext = `.phase-tabs [data-tab="${swiperContainer.dataset.tab}"] .swiper-button-next`;
                    const swiperPrev = `.phase-tabs [data-tab="${swiperContainer.dataset.tab}"]  .swiper-button-prev`;
                    this.swipers.push(new Swiper(swiperContainer, {
                        grabCursor: true,
                        mousewheel: false,
                        observer: true,
                        observeParents: true,
                        scrollbar: {
                            el: '.swiper-scrollbar',
                            hide: false,
                        },
                        navigation: false,
                        spaceBetween: 20,
                        breakpoints: {
                            0: {
                                slidesPerView: 1,
                            },
                            576: {
                                slidesPerView: 2,
                            },
                            768: {
                                slidesPerView: 4,
                            },
                            1200: {
                                slidesPerView: 6,
                            },
                        },
                    }));
                });
            }
        };
        this.destroySwiper = () => {
            if (this.swipers) {
                this.swipers.forEach((swiper) => {
                    swiper.destroy();
                });
                this.swipers = null;
            }
        };
        this.swiperContainers = container.querySelectorAll('.phase-tabs__content-wrapper');
        this.tabs = container.querySelectorAll('.phase-tabs__tabs-tab');
        const onWindowResize = debounce(() => {
            if (isMobile) {
                this.tabs[0].click();
            }
        }, 200);
        onWindowResize();
        //window.addEventListener('resize', onWindowResize);
        this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => {
                this.switchTab(tab);
            });
        });
    }
}
export default PhaseTabs;
